"use client";

import { c as _c } from "react/compiler-runtime";
import { type RefObject, useEffect } from "react";
import { loadGsapWithScrollTrigger, shouldReduceMotion } from "@/lib/gsap";
export function useAboutCardsAnimation(sectionRef) {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] !== sectionRef) {
    t0 = () => {
      if (shouldReduceMotion()) {
        return;
      }
      let cleanup;
      let cancelled = false;
      const setupAnimation = async function setupAnimation() {
        const {
          gsap
        } = await loadGsapWithScrollTrigger();
        if (cancelled) {
          return;
        }
        const ctx = gsap.context(() => {
          const cards = gsap.utils.toArray(".about-card");
          gsap.set(cards, {
            opacity: 0,
            y: 26,
            filter: "blur(8px)"
          });
          gsap.to(cards, {
            opacity: 1,
            y: 0,
            filter: "blur(0px)",
            duration: 1.5,
            ease: "power3.out",
            stagger: {
              each: 0.14,
              from: "start"
            },
            scrollTrigger: {
              trigger: ".about-cards-grid",
              start: "top 85%",
              toggleActions: "restart reverse restart reverse"
            }
          });
        }, sectionRef);
        cleanup = () => ctx.revert();
      };
      setupAnimation();
      return () => {
        cancelled = true;
        cleanup?.();
      };
    };
    t1 = [sectionRef];
    $[0] = sectionRef;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
}